// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NeOw","delete":"styles_delete__2EWlZ","update":"styles_update__1XjoY","add":"styles_add__1BD6t"};